import { Component } from '@angular/core';
import { ProviderService } from '@modules/private/provider/data/services/view/provider.service';

@Component({
  selector: 'app-provider-form',
  templateUrl: './provider-form.component.html',
  styleUrls: ['./provider-form.component.scss']
})
export class ProviderFormComponent {
  statuses: { label: string; value: string; }[] = [
    { label: "Activo", value: "ACTIVE" },
    { label: "Bloqueado", value: "LOCKED" },
    { label: "Eliminado", value: "DELETED" }
  ];

  constructor(
    public providerService: ProviderService
  ) {
  }

  get e() {
    return this.providerService.entity;
  }
}